import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { resolveImage, categoryLabel, formatDate } from "@/lib/api";
import { useLang, pick } from "@/context/LangContext";

const catColor = {
  story: "bg-[var(--saffron-tint)] text-[var(--saffron-deep)]",
  growth: "bg-[var(--green-tint)] text-[var(--india-green-deep)]",
  geopolitics: "bg-[var(--chakra)] text-white",
  general: "bg-stone-100 text-stone-700",
};

export function ArticleCard({ article, index = 0 }) {
  const { lang } = useLang();
  const img = resolveImage(article.cover_image);
  const title = pick(article, "title", lang);
  const excerpt = pick(article, "excerpt", lang);
  return (
    <Link
      to={`/articles/${article.slug}`}
      data-testid={`article-card-${article.slug}`}
      className="card-lift group flex flex-col overflow-hidden rounded-2xl border border-[var(--line)] bg-white reveal"
      style={{ animationDelay: `${0.05 * index}s` }}
    >
      <div className="relative aspect-[16/10] overflow-hidden bg-[var(--saffron-tint)]">
        {img ? (
          <img src={img} alt={article.title} loading="lazy" className="h-full w-full object-contain transition-transform duration-700 group-hover:scale-[1.03]" />
        ) : (
          <div className="flex h-full items-center justify-center font-devanagari text-4xl text-[var(--saffron)]">भारत</div>
        )}
      </div>
      <div className="flex flex-1 flex-col p-5">
        <div className="flex items-center gap-2 text-xs">
          <span className={`rounded-full px-2.5 py-1 font-semibold uppercase tracking-wider ${catColor[article.category] || catColor.general}`}>
            {categoryLabel(article.category)}
          </span>
          {article.state && <span className="text-stone-500">· {article.state}</span>}
        </div>
        <h3 className={`mt-3 text-lg font-semibold leading-snug text-[var(--chakra-deep)] transition-colors group-hover:text-[var(--saffron-deep)] ${lang === "hi" && article.title_hi ? "font-devanagari text-xl" : "font-serif"}`}>
          {title}
          {article.content_hi && <span className="ml-2 align-middle rounded bg-[var(--saffron-tint)] px-1.5 py-0.5 font-devanagari text-[11px] font-normal text-[var(--saffron-deep)]" title="Hindi version available">हिं</span>}
        </h3>
        <p className="mt-2 line-clamp-3 flex-1 text-sm text-stone-600">{excerpt}</p>
        <div className="mt-4 flex items-center justify-between text-xs text-stone-500">
          <span>{formatDate(article.published_at)}</span>
          <span className="inline-flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> {article.read_time} min</span>
        </div>
      </div>
    </Link>
  );
}
